import { usePodcastProvider } from "./PodcastProvider";
import { PodcastDetails } from "./PodcastDetails";
import { FeaturedContent } from "./FeaturedContent";
//ui
import { Flex, Skeleton, Stack } from "@chakra-ui/react";

export function Hero() {
  const { isOpen, podcastData } = usePodcastProvider();
  const showComponents = isOpen ? "none" : "flex";

  return (
    <Flex width="100%" position="relative" mt={{ base: "43px", md: "88px" }} pb={{ base: "55px", sm: "50px" }} fontFamily="sora" flexDirection="column" display={{ base: showComponents, md: "flex" }}>
      <Flex px={{ base: "39px", sm: "32px" }} maxWidth="1384px" width="100%" margin="auto" flexDir={{ base: "column", md: "row" }} justifyContent="space-between">
        <Flex maxWidth={{ base: "100%", md: "35%" }} width="100%" flexDir="column" mr="30px">
          <PodcastDetails />
        </Flex>
        <Flex maxWidth={{ base: "100%", md: "42%" }} width="100%" flexDir="column" alignItems="flex-end" mt={{ base: "32px", md: "0px" }}>
          {podcastData.length > 0 ? (
            <FeaturedContent />
          ) : (
            <Stack width="100%">
              <Skeleton height="352px" borderRadius={{ base: "12px", md: "16px" }}></Skeleton>
              <Skeleton height="112px" borderRadius={{ base: "12px", md: "16px" }}></Skeleton>
            </Stack>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
}
